export default "__VITE_ASSET__vEVrzU2u__"